import req from "@/assets/js/axios"

// 华转网平台相关接口
export default {
  /** 条件查询政策（前台）*/
  getPolicys: (params) => {
    return req.apiAxios('POST', '/sctccHost/policy/PolicyController/getPolicys', params);
  },
   /** 条件查询活动*/
   getActivities: (params) => {
    return req.apiAxios('POST', '/sctccHost/activity/ActivityController/getActivities', params);
  },
  // 条件查询专利
  getPatents: (params) => {
    return req.apiAxios("POST", '/sctccHost/patent/PatentController/getPatents', params)
  },
  // 条件查询仪器共享
  getInstruments: (params) => {
    return req.apiAxios("POST", '/sctccHost/instrument/InstrumentController/getInstruments', params)
  },
  // 条件查询政策
  getESPolicys: (params, auth) => {
    return req.apiAxios("POST", '/sctccHost/search/policy/ESPolicyController/getESPolicys', params, auth)
  },
  // 条件查询政策
  getRelates: (params, auth) => {
    return req.apiAxios("POST", '/sctccHost/policyrelated/PolicyRelatedController/getRelates', params, auth)
  },
  // 条件查询政策
  downloadPolicyWordZip: (params, auth) => {
    return req.apiAxios("POST", '/sctccHost/policy/PolicyController/downloadPolicyWordZip', params, auth)
  },
  // 条件查询政策
  recordDown: (params, auth) => {
    return req.apiAxios("POST", '/sctccHost/policy/PolicyController/record', params, auth)
  },
  // 条件查询政策
  getPolicyByIds: (params, auth) => {
    return req.apiAxios("POST", '/sctccHost/policy/PolicyController/getPolicyByIds', params, auth)
  },
  // 条件查询政策
  exportDBExcel: (params, auth) => {
    return req.apiAxios("POST", '/sctccHost/policy/PolicyController/exportExcel', params, auth)
  },
}
